<template>
  <div class="cttl-Loader">
    <div v-for="row in ROWS" :key="row" class="cttl-Loader_Row">
      <div class="cttl-Cell">
        <SkeletonItem :appearance="SKELETON_APPEARANCES.CIRCLE" :size="XS" />
        <SkeletonItem :size="XS" :width="row.name" />
      </div>

      <div class="cttl-Cell" style="--gap: 4px">
        <SkeletonItem
          v-for="n in row.workspaces"
          :key="n"
          :appearance="SKELETON_APPEARANCES.SQUARE"
          :size="SM"
          border-radius="6px"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import {
  SKELETON_APPEARANCES,
  SKELETON_SIZES
} from '@/utils/components-configurations/skeleton-item'

import SkeletonItem from '@/components/ui/SkeletonLoaders/SkeletonItem'

defineOptions({
  name: 'CheckinsTemplatesTableLoader'
})

const { XS, SM } = SKELETON_SIZES

const ROWS = [
  {
    id: 0,
    name: '190px',
    workspaces: 4
  },
  {
    id: 1,
    name: '130px',
    workspaces: 1
  },
  {
    id: 2,
    name: '490px',
    workspaces: 3
  },
  {
    id: 3,
    name: '220px',
    workspaces: 2
  },
  {
    id: 4,
    name: '90px',
    workspaces: 4
  }
]
</script>

<style lang="scss" scoped>
.cttl-Loader_Row {
  height: 45px;
  display: flex;
  align-items: center;
  padding: 0 $page-right-padding 0 $page-left-padding;
  width: 100%;
}

.cttl-Cell {
  display: flex;
  align-items: center;
  gap: var(--gap, 2px);

  &:first-child {
    flex: 1 1 100%;
  }

  &:nth-child(2) {
    flex: 1 0 184px;
    justify-content: flex-start;
  }
}
</style>
